const GoogleMap = ({ location = 'leipzig', className = '' }) => {
  // Google Maps Embed URLs for both locations
  const mapUrls = {
    leipzig: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2493.0!2d12.3347!3d51.3193!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a6f8c0!2sZschochersche%20Str.%2049%2C%2004229%20Leipzig!5e0!3m2!1sde!2sde!4v1",
    halle: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2493.0!2d11.9699!3d51.4818!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a6f8c0!2sMerseburger%20Str.%2019%2C%2006112%20Halle%20(Saale)!5e0!3m2!1sde!2sde!4v1"
  };

  // Fallback addresses for direct Google Maps search
  const addresses = {
    leipzig: "Zschochersche+Str.+49,+04229+Leipzig,+Germany",
    halle: "Merseburger+Str.+19,+06112+Halle+(Saale),+Germany"
  };

  const embedUrl = `https://www.google.com/maps?q=${addresses[location]}&output=embed`;

  return (
    <div className={`rounded-2xl overflow-hidden shadow-lg ${className}`} data-testid={`google-map-${location}`}>
      <iframe
        src={embedUrl}
        width="100%"
        height="300"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title={`Standort ${location === 'leipzig' ? 'Leipzig' : 'Halle (Saale)'}`}
      />
    </div>
  );
};

export default GoogleMap;
